import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { SelfTriageCounselingService } from 'src/app/shared/services/API/self-triage/self-triage-counseling.service';

@Component({
  selector: 'app-self-triage-counseling-delete-modal',
  templateUrl: './self-triage-counseling-delete-modal.component.html',
  styleUrls: ['./self-triage-counseling-delete-modal.component.css']
})
export class SelfTriageCounselingDeleteModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, 
    public dialog: MatDialog, 
    public matDialogRef: MatDialogRef<SelfTriageCounselingDeleteModalComponent>,
    private selfTriageCounselingService: SelfTriageCounselingService,
    private alertService: AlertService,
  ) { }

  public isLoading:boolean;  

  ngOnInit(): void {
    this.isLoading = false;
  }
  
  close(){
    this.matDialogRef.close({deleteCounseling: false}); 
  }
  
  clickDelete(){
    
    this.isLoading = true;

    this.selfTriageCounselingService.deleteCounseling(this.data.idSelfTriageCounseling).subscribe((response)=>{
      
      if(response.isError){
        this.alertService.show('Erro', response.errorDescription, AlertType.error);
        this.isLoading = false;
        return;
      }
      
      this.alertService.show('Sucesso', "Aconselhamento excluído com sucesso!", AlertType.success); 
      this.matDialogRef.close({deleteCounseling: true}); 
    },
    (error)=>{
      console.log(error)
      this.isLoading = false;
      this.alertService.show('Erro inesperado', error, AlertType.error);
    });
  }
  
  clickCancel(){
    this.matDialogRef.close({deleteCounseling: false}); 
  }
}